import { COLOR_PALETTE } from 'constants/ui';

export const titleWrapperStyles = {
  display: 'grid',
  gridTemplateColumns: '240px 1fr auto',
  alignItems: 'center',
  padding: '20px 0',
};

export const titleStyles = {
  paddingLeft: '24px',
  color: ({ palette }) => palette.text.primary,
  fontSize: '2rem',
  fontWeight: 700,
};

export const addButtonStyles = {
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
  width: 'fit-content',
  height: 'fit-content',
  justifySelf: 'end',
  marginRight: '24px',
  fontSize: '1.4rem',
  fontWeight: 400,
  color: COLOR_PALETTE.BRAND[6],
  textTransform: 'none',

  '&[disabled]': {
    opacity: 0.7,
    color: COLOR_PALETTE.BRAND[6],
  },
};

export const additionalNavigationContentStyles = {
  display: 'flex',
  gap: '8px',
  alignItems: 'center',
  flexWrap: 'nowrap',
  padding: '8px 0 4px',
};

export const additionalNavigationTextStyles = {
  color: ({ palette }) => palette.text.primary,
  fontSize: '1.2rem',
  userSelect: 'none',
};

export const dividerStyles = {
  borderColor: ({ palette }) => palette.border.default,
  borderBottomWidth: 0,
};
